import { useEffect } from "react";

import MonobankIco from "../assets/icons/banks/MonoBank.png";
import AlphaIco from "../assets/icons/banks/AlfaBank.svg";
import IziIco from "../assets/icons/banks/IziBank.png";
import KaspiIco from "../assets/icons/banks/KaspiBank.png";
import OzonIco from "../assets/icons/banks/OzonBank.jpg";
import PrivatIco from "../assets/icons/banks/PrivatBank.png";
import RaifizenIco from "../assets/icons/banks/RaiffeisenBank.png";
import SberIco from "../assets/icons/banks/SberBank.png";
import TBankIco from "../assets/icons/banks/TBank.png";

const Dropdown = ({
  text,
  listMenu,
  setSelectedItem,
  selectedItem,
  setSelectedRender,
  openDropdown,
  setOpenDropdown,
  dropdownName,
}) => {
  const isOpen = openDropdown === dropdownName;

  const toggleMenu = () => {
    setOpenDropdown(isOpen ? null : dropdownName);
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setSelectedRender(null);
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".input")) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setOpenDropdown]);

  function removeColorCircles(str) {
    return str.replace(/[\u{1F7E0}-\u{1F7EB}\u{1F534}-\u{1F535}\u26AB\u26AA]\uFE0F?\s*/gu, "");
  }

  const getIcon = (name) => {
    let currenIcon = 0;

    if (name === "Izi 🟠") {
      currenIcon = IziIco;
    } else if (name === "Alfa 🔴") {
      currenIcon = AlphaIco;
    } else if (name === "Kaspi 🔴") {
      currenIcon = KaspiIco;
    } else if (name === "Ozon 🔵") {
      currenIcon = OzonIco;
    } else if (name === "Privat24 🟢") {
      currenIcon = PrivatIco;
    } else if (name === "Raiffeisen 🟡") {
      currenIcon = RaifizenIco;
    } else if (name === "Mono ⚫️") {
      currenIcon = MonobankIco;
    } else if (name === "Sber 🟢") {
      currenIcon = SberIco;
    } else if (name === "T-Bank 🟡") {
      currenIcon = TBankIco;
    }

    return currenIcon;
  };

  const icon = getIcon(selectedItem?.name);

  return (
    <>
      <div
        className="input flex justify-between py-5 px-6 items-center cursor-pointer select-none text-[#B7B7B7] bg-white rounded-sm"
        onClick={toggleMenu}
      >
        <span className="truncate text-[#0B1F24] flex items-center gap-4 font-secondaryTitle text-2xl">
          {selectedItem && icon !== 0 && icon && (
            <img src={icon} alt="icon" className="h-[30px] rounded-[8px]" />
          )}
          {selectedItem ? removeColorCircles(selectedItem?.name) : text}
        </span>
        <svg
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={isOpen ? "rotate" : ""}
        >
          <path
            d="M7.75593 8.12713C7.35716 8.58759 6.64284 8.58759 6.24407 8.12713L0.638744 1.65465C0.0778678 1.00701 0.53792 -5.55611e-07 1.39467 -6.3051e-07L12.6053 -1.61058e-06C13.4621 -1.68548e-06 13.9221 1.00701 13.3613 1.65465L7.75593 8.12713Z"
            fill="#5F6260"
          />
        </svg>
      </div>

      <ul
        className={`input__submenu absolute hidden left-[67px] right-0 list-none mt-2 p-0 bg-[#F2F2F2] border-solid border border-[#ccc] rounded-sm z-10 ${
          isOpen ? "show" : ""
        }`}
      >
        {listMenu &&
          listMenu.map((item, index) => (
            <li key={index} className="hover:bg-[#D5D4D4]" onClick={() => handleItemSelect(item)}>
              <div className="flex gap-4 items-center">
                {getIcon(item.name) !== 0 ? (
                  <div className="input__icon">
                    <img
                      className="input__icon-img h-[30px] rounded-[8px]"
                      src={getIcon(item.name)}
                      alt="Monobank"
                    />
                  </div>
                ) : (
                  ""
                )}

                <h3 className="font-secondaryTitle text-2xl">{removeColorCircles(item.name)}</h3>
                <p className="truncate font-body text-[#6C6C6C] text-sm"></p>
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};

export default Dropdown;
